var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex--space-between--center header__dropdown-containter"},[_c('div',{staticClass:"photo__container",style:(_vm.doctorPhotoStyles)}),_c('div',{staticClass:"header__doctor-name-container"},[_c('div',[_vm._v(_vm._s(_vm.doctorFullName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }